export default __webpack_public_path__ + "static/media/Correct_color.3de5db2a.svg";